import { render, staticRenderFns } from "./OrgSelection.vue?vue&type=template&id=17c32861&scoped=true&"
import script from "./OrgSelection.vue?vue&type=script&lang=js&"
export * from "./OrgSelection.vue?vue&type=script&lang=js&"
import style0 from "./OrgSelection.vue?vue&type=style&index=0&id=17c32861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c32861",
  null
  
)

export default component.exports